export enum ComponentId {
  DRIVER_NAME = "name",
  DRIVER_SURNAME = "surname",
  DRIVER_PHONE = "phone",
  DRIVER_PESEL = "pesel",
  DRIVER_LACK_OF_PESEL = "lackOfPesel",
  DRIVER_OTHER_ID = "otherId",
  DRIVER_OTHER_ID_NUMBER = "otherIdNumber",
  DRIVER_STREET = "street",
  DRIVER_STREET_2 = "street2",
  DRIVER_ZIP_CODE = "zipCode",
  DRIVER_CITY = "city",
  DRIVER_PROVINCE = "province",
}
